/**
 * Formats a date string to the format "dd. mm. yyyy".
 * @param date - The date string to format.
 * @returns The formatted date string.
 */
export const formatDate = (date: string) => {
  const dateObject = new Date(date);
  const day = dateObject.getDate() < 10 ? '0' + dateObject.getDate() : dateObject.getDate();
  const month = dateObject.getMonth() + 1 < 10 ? '0' + (dateObject.getMonth() + 1) : dateObject.getMonth() + 1;
  const year = dateObject.getFullYear();

  const COUNTRY = window.country || process.env.REACT_APP_COUNTRY;

  if (COUNTRY === 'hu') {
    return `${year}. ${month}. ${day}.`;
  }

  return `${day}. ${month}. ${year}`;
};

/**
 * Formats a URL by appending the base URL if it's not already included.
 * @param url - The URL to format.
 * @returns The formatted URL.
 */
export const formatUrl = (url: string) => {
  const baseUrl = window.crmUrl || process.env.REACT_APP_CRM_BASE_URI;

  if (!baseUrl) {
    return url;
  }

  if (url && url.includes(baseUrl)) {
    return url;
  }

  return baseUrl + url;
};

export const formatPrice = (price: number, currency: string): string => {
  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: 0,
  };

  const locale = 'sk'; // This is explicitly requested by the client for all countries.
  const formatter = new Intl.NumberFormat(locale, options);

  return formatter.format(price);
};
